// Regulatory Calendar: the routes of `wealth.compliance.regulatory-calendar`
// (ADR-0027). The calendar has no sidebar row of its own: the Comply
// Dashboard links to it.
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.regulatory-calendar',
    routes: [
        {
            frontend: 'comply',
            path: 'reg-calendar',
            lazy: () => import('@/pages/comply/reg-calendar/page'),
        },
        {
            frontend: 'view',
            path: 'reg-calendar',
            lazy: () => import('@/pages/view/reg-calendar/page'),
        },
    ],
});
